/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NatureFxLightningAIcon16Light = forwardRef('NatureFxLightningAIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.721 1.618A.75.75 0 0 1 5.459 1h4.71a.75.75 0 0 1 .72.956L9.735 6h2.473a.75.75 0 0 1 .569 1.238L6.252 14.85c-.502.586-1.456.122-1.305-.635L5.99 9H4.3a.75.75 0 0 1-.739-.882l1.161-6.5ZM5.669 2 4.597 8h1.698a.75.75 0 0 1 .736.897l-.915 4.575L11.663 7h-2.26a.75.75 0 0 1-.721-.956L9.837 2H5.67Z" })));
});
